import { c as _c } from "react/compiler-runtime";
import type { DataIdentifier, Entity } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import type { Fieldset } from '../../../../vault.types';
import CorporationType from './components/corporation-type';
const useFieldsets = () => {
  const $ = _c(20);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "vault"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("business-details", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [{
      di: "business.name"
    }, {
      di: "business.dba"
    }, {
      di: "business.tin"
    }, {
      di: "business.corporation_type",
      renderCustomField: _temp2
    }, {
      di: "business.website"
    }, {
      di: "business.phone_number"
    }, {
      di: "business.formation_state"
    }, {
      di: "business.formation_date"
    }];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = {
      title: t1,
      fields: t2
    };
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp3);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [{
      di: "business.country"
    }, {
      di: "business.address_line1"
    }, {
      di: "business.address_line2"
    }, {
      di: "business.city"
    }, {
      di: "business.zip"
    }, {
      di: "business.state"
    }];
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = {
      title: t4,
      fields: t5
    };
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t(_temp4);
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [];
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7) {
    t9 = {
      title: t7,
      fields: t8
    };
    $[14] = t7;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t3 || $[17] !== t6 || $[18] !== t9) {
    t10 = {
      basic: t3,
      address: t6,
      custom: t9
    };
    $[16] = t3;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};
export default useFieldsets;
function _temp($) {
  return $.basic.title;
}
function _temp2(t0) {
  const {
    di,
    entity
  } = t0;
  return <CorporationType di={di} entity={entity} />;
}
function _temp3($_0) {
  return $_0.address.title;
}
function _temp4($_1) {
  return $_1.custom.title;
}